import { Box } from "@mui/material";
import React from "react";

interface ChartWrapperProps {
  children: React.ReactNode;
  height?: string | number;
  width?: string | number;
}

const ChartWrapper: React.FC<ChartWrapperProps> = ({
  children,
  height = "auto",
  width = "100%",
}) => {
  return (
    <Box
      sx={{
        height,
        width,
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        marginBottom: "-20px",
        paddingTop: "10px",
        "& canvas": {
          maxWidth: "100%",
        },
        "& .chartjs-legend-items": {
          display: "flex",
          justifyContent: "center",
          gap: "30px",
        },
        "& .chartjs-legend-item": {
          marginRight: "10px",
        },
        "& ul.chartjs-legend": {
          display: "flex !important",
          justifyContent: "center",
          gap: "25px",
          marginTop: "10px",
        },
      }}
    >
      {children}
    </Box>
  );
};

export default ChartWrapper;
